import { Box, Typography } from "@mui/material";
import {
    FREE_GREEN,
    NFB_SESSION_ONLY_BG,
    NFB_FULL_BG,
    NFB_BLOCKED_GREY,
    PSY_RESERVATION_BLUE,
    PSY_BOOKING_ONLY_BG,
} from "./gridUtils";

type GridLegendProps = {
    showPsy: boolean;
    showNfb: boolean;
};

type LegendItem = {
    color: string;
    label: string;
};

const PSY_ITEMS: Array<LegendItem> = [
    { color: FREE_GREEN, label: "Reserva disponível" },
    { color: PSY_RESERVATION_BLUE, label: "Reservado" },
    { color: PSY_BOOKING_ONLY_BG, label: "Sessão sem reserva" },
];

const NFB_ITEMS: Array<LegendItem> = [
    { color: FREE_GREEN, label: "Reserva disponível" },
    { color: NFB_SESSION_ONLY_BG, label: "Só sessão (sem reserva)" },
    { color: NFB_FULL_BG, label: "Sem vaga" },
    { color: NFB_BLOCKED_GREY, label: "Bloqueado" },
];

const LegendRow = ({ title, items }: { title: string; items: Array<LegendItem> }) => {
    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 1.5, rowGap: 0.5 }}>
            <Typography variant="caption" sx={{ fontWeight: "bold", fontSize: "11px", color: "text.secondary", minWidth: 90 }}>
                {title}
            </Typography>
            {items.map((item) => (
                <Box key={item.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Box
                        sx={{
                            width: 11,
                            height: 11,
                            borderRadius: "2px",
                            backgroundColor: item.color,
                            border: "1px solid",
                            borderColor: "divider",
                        }}
                    />
                    <Typography variant="caption" sx={{ fontSize: "11px", color: "text.secondary" }}>
                        {item.label}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export const GridLegend = ({ showPsy, showNfb }: GridLegendProps) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {showPsy && <LegendRow title="Psicologia" items={PSY_ITEMS} />}
            {showNfb && <LegendRow title="Neurofeedback" items={NFB_ITEMS} />}
        </Box>
    );
};
